import React from 'react';

export const messagingStatusSettings = {
  NO_SEND_RECORDED: {
    color: '#666',
    backgroundColor: '#F5F5F54D',
    label: 'Sem envio registrado',
  },
  MESSAGE_RECEIVED: {
    color: '#219BE4',
    backgroundColor: '#F0FDFD4D',
    label: 'Mensagem entregue',
  },
  MESSAGE_READ: {
    color: '#2F7D00',
    backgroundColor: '#E2FDD14D',
    label: 'Mensagem lida',
  },
  MESSAGE_NOT_RECEIVED: {
    color: '#7D3300',
    backgroundColor: '#FDE3D14D',
    label: 'Mensagem não recebida',
  },
  SEND_FAILED: {
    color: '#7D0000',
    backgroundColor: '#FDD4D14D',
    label: 'Falha no envio',
  },
};

const defaultSettings = messagingStatusSettings.NO_SEND_RECORDED;

export const messagingStatusOptions = Object.entries(messagingStatusSettings).map(
  ([value, { label }]) => ({ value, label })
);

export const translateMessagingStatus = (status) => {
  const settings = messagingStatusSettings[status] || defaultSettings;
  return settings.label;
};

const parseMessagingStatus = (status) => {
  const settings = messagingStatusSettings[status] || defaultSettings;

  return (
    <span
      style={{
        color: settings.color,
        backgroundColor: settings.backgroundColor,
        padding: '5px 8px',
        borderRadius: '3px',
        display: 'block',
        textAlign: 'center',
        border: `1px solid ${settings.color}`,
      }}
    >
      {settings.label}
    </span>
  );
};

export default parseMessagingStatus;